import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import ComponentState from './states'

const mutations: MutationTree<ComponentState> = {
  [mutationType.SNACKBAR](state: ComponentState, data: ComponentState['snackbar']): void {
    state.snackbar = data
  },
  [mutationType.TITLEPAGE](state: ComponentState, title: string): void {
    state.titlePage = title
  },
  [mutationType.APP](state: ComponentState, app: string): void {
    state.app = app
  },
  [mutationType.PAGE_START_LOADING](state: ComponentState): void {
    state.pageLoading = true
  },
  [mutationType.PAGE_STOP_LOADING](state: ComponentState): void {
    state.pageLoading = false
  },
  [mutationType.SET_LEVEL](state: ComponentState, level: {id?: string, mode: string}): void {
    state.user.level = level
  },
  [mutationType.READY](state: ComponentState, isReady: boolean): void {
    console.log('READY', isReady)
    state.ready = isReady
  },
}

export default mutations
